/*! Vintage Audio Store 360 spin viewer - vanilla JS, no dependencies.
 * Markup (e.g. in a product description):
 *   <div class="vas-spin" data-base="https://.../spin-" data-count="36"
 *        data-poster="https://.../poster.jpg" data-loop="true" data-start="0"
 *        data-alt="Garrard Zero 100 positioning gauge"></div>
 * Optional: data-ext=".jpg" (default), data-pad="2" (spin-00), data-ratio="4/5",
 *           data-autospin="false" to disable the one-time intro spin.
 * Frames: base + zero-padded index + ext, i.e. spin-00.jpg ... spin-35.jpg
 * Also upgrades <img src=".../edited/spin/<slug>/poster.jpg|webp?vas-spin=N&vas-loop=1&vas-start=K[&vas-ext=webp]"> (see upgradeImgs).
 * Frame extension follows the poster's (poster.webp -> spin-NN.webp) unless vas-ext overrides it.
 * No-op on pages without either form.
 */
(function(){
  'use strict';
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function pad(n,w){n=String(n);while(n.length<w)n='0'+n;return n;}
  // order frames so coverage is coarse-to-fine: 0, n/2, n/4, 3n/4, ...
  function loadOrder(n,start){
    var out=[],seen={},step=n;
    while(step>=1){for(var i=0;i<n;i+=step){var k=(i+start)%n;if(!seen[k]){seen[k]=1;out.push(k);}}step=Math.floor(step/2);}
    for(var j=0;j<n;j++)if(!seen[j])out.push(j);
    return out;
  }
  function init(root){
    if(root.__vasSpin)return; root.__vasSpin=true;
    var base=root.getAttribute('data-base'), n=parseInt(root.getAttribute('data-count'),10);
    if(!base||!(n>1))return;
    var ext=root.getAttribute('data-ext')||'.jpg', w=parseInt(root.getAttribute('data-pad')||'2',10);
    var loop=root.getAttribute('data-loop')!=='false';
    var start=Math.min(n-1,Math.max(0,parseInt(root.getAttribute('data-start')||'0',10)||0));
    var poster=root.getAttribute('data-poster');
    var alt=root.getAttribute('data-alt')||'Product';
    var autospin=root.getAttribute('data-autospin')!=='false'&&!reduce;
    var ratio=root.getAttribute('data-ratio'); if(ratio)root.style.setProperty('--vas-spin-ratio',ratio);
    var urls=[];for(var i=0;i<n;i++)urls.push(base+pad(i,w)+ext);
    var cache=new Array(n), loaded=0, cur=start, uid='vas-spin-'+Math.random().toString(36).slice(2,8);

    root.innerHTML='';
    var stage=document.createElement('div');stage.className='vas-spin__stage';
    stage.setAttribute('role','img');stage.setAttribute('aria-label',alt+' - 360 degree view. Drag or use the slider to rotate.');
    var img=document.createElement('img');img.className='vas-spin__img';img.alt=alt;img.decoding='sync';img.draggable=false;
    img.src=poster||urls[start];
    var badge=document.createElement('span');badge.className='vas-spin__badge';badge.textContent=loop?'360\u00B0 \u2194 drag':'\u2194 drag to turn';
    var prog=document.createElement('span');prog.className='vas-spin__progress';
    stage.appendChild(img);stage.appendChild(badge);stage.appendChild(prog);
    var ctr=document.createElement('div');ctr.className='vas-spin__controls';
    var label=document.createElement('label');label.className='vas-spin__label';label.htmlFor=uid;label.textContent='Drag to spin';
    var range=document.createElement('input');range.type='range';range.id=uid;range.className='vas-spin__range';
    range.min='0';range.max=String(n-1);range.step='1';range.value=String(start);
    range.setAttribute('aria-label','Rotate '+alt);
    ctr.appendChild(range);ctr.appendChild(label);
    root.appendChild(stage);root.appendChild(ctr);

    function angleText(i){return loop?Math.round(i*360/n)+'\u00B0':'view '+(i+1)+' of '+n;}
    function show(i){
      i=loop?((i%n)+n)%n:Math.max(0,Math.min(n-1,i));
      cur=i;range.value=String(i);range.setAttribute('aria-valuetext',angleText(i));
      var c=cache[i];
      if(c&&c.complete&&c.naturalWidth){img.src=c.src;return;}
      // nearest already-loaded frame while the exact one loads
      for(var d=1;d<n;d++){var a=cache[(i+d)%n],b=cache[(i-d+n)%n];
        if(a&&a.naturalWidth){img.src=a.src;break;} if(b&&b.naturalWidth){img.src=b.src;break;}}
    }
    function preload(){
      var order=loadOrder(n,start),k=0,inflight=0,MAX=4;
      function next(){
        while(inflight<MAX&&k<order.length){(function(idx){
          inflight++;var im=new Image();
          var done=function(){inflight--;loaded++;prog.style.width=(100*loaded/n)+'%';
            if(idx===cur&&im.naturalWidth)img.src=im.src;
            if(loaded>=n){root.classList.add('is-loaded');root.dispatchEvent(new CustomEvent('vas-spin:loaded'));maybeAuto();}
            next();};
          // decode before counting as ready so swapping frames never flashes blank
          im.onload=function(){if(im.decode){im.decode().then(done,done);}else done();};
          im.onerror=done;
          im.src=urls[idx];cache[idx]=im;})(order[k++]);}
      }
      next();
    }
    // --- interaction
    var dragging=false,lastX=0,acc=0,touched=false;
    function pxPerFrame(){return Math.max(4,stage.clientWidth/(loop?n:n*0.9));}
    function touch(){if(!touched){touched=true;root.classList.add('is-touched');}stopAuto();}
    stage.addEventListener('pointerdown',function(e){if(e.button!==undefined&&e.button!==0)return;
      dragging=true;lastX=e.clientX;acc=0;touch();root.classList.add('is-dragging');
      try{stage.setPointerCapture(e.pointerId);}catch(_){}});
    stage.addEventListener('pointermove',function(e){if(!dragging)return;
      acc+=e.clientX-lastX;lastX=e.clientX;var step=pxPerFrame();
      while(Math.abs(acc)>=step){var s=acc>0?1:-1;show(cur+s);acc-=s*step;}
      e.preventDefault();});
    function end(){dragging=false;root.classList.remove('is-dragging');}
    stage.addEventListener('pointerup',end);stage.addEventListener('pointercancel',end);stage.addEventListener('lostpointercapture',end);
    range.addEventListener('input',function(){touch();show(parseInt(range.value,10));});
    range.addEventListener('keydown',function(e){ // wrap-around for looping spins
      if(!loop)return; var v=parseInt(range.value,10);
      if((e.key==='ArrowRight'||e.key==='ArrowUp')&&v===n-1){e.preventDefault();touch();show(0);}
      else if((e.key==='ArrowLeft'||e.key==='ArrowDown')&&v===0){e.preventDefault();touch();show(n-1);}
    });
    // --- one-time intro spin (skipped with prefers-reduced-motion or data-autospin="false")
    var autoTimer=null,autoDone=false,visible=false;
    function stopAuto(){if(autoTimer){clearInterval(autoTimer);autoTimer=null;}autoDone=true;}
    function maybeAuto(){
      if(!autospin||autoDone||touched||!visible||!root.classList.contains('is-loaded'))return;
      autoDone=true;var steps=0,total=loop?n:2*(n-1),dir=1,from=cur;
      autoTimer=setInterval(function(){
        if(loop){show(cur+1);}else{if(cur+dir>n-1||cur+dir<0)dir=-dir;show(cur+dir);}
        if(++steps>=total){clearInterval(autoTimer);autoTimer=null;if(!loop)show(from);}
      },Math.max(30,1800/total));
    }
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(en){
        if(en.isIntersecting){visible=true;if(!root.__vasStarted){root.__vasStarted=true;preload();}maybeAuto();}
        else visible=false;});},{rootMargin:'200px'});
      io.observe(root);
    }else{visible=true;preload();}
    root.vasSpin={show:show,get frame(){return cur;},count:n};
  }
  // Rich-text-safe embed: a plain <img> of an S3 spin poster, settings in the query string, e.g.
  //   <img src="https://service-manual-images.s3.amazonaws.com/edited/spin/<slug>/poster.jpg?vas-spin=36&vas-loop=1&vas-start=0" alt="...">
  // Without JS (or if anything is missing) the poster simply stays as a normal image.
  var POSTER_RE=/^(https:\/\/[^?#]+\/edited\/spin\/[^\/?#]+\/)poster\.(jpg|webp)(?:\?([^#]*))?/i;
  function upgradeImgs(){
    var imgs=document.querySelectorAll('img[src*="/edited/spin/"]');
    for(var i=0;i<imgs.length;i++){
      var im=imgs[i]; if(im.__vasSpin)continue;
      var m=POSTER_RE.exec(im.getAttribute('src')||''); if(!m)continue;
      var q={}; (m[3]||'').split('&').forEach(function(kv){var p=kv.split('=');if(p[0])q[decodeURIComponent(p[0])]=decodeURIComponent(p[1]||'');});
      var n=parseInt(q['vas-spin'],10); if(!(n>1&&n<=360))continue;
      im.__vasSpin=true;
      var d=document.createElement('div');d.className='vas-spin';
      d.setAttribute('data-base',m[1]+'spin-');d.setAttribute('data-count',String(n));
      // reuse the exact poster URL (query included) so the browser doesn't fetch the poster twice
      d.setAttribute('data-poster',im.currentSrc||im.src);
      var ext=(q['vas-ext']||m[2]||'jpg').replace(/[^a-z0-9]/gi,'');d.setAttribute('data-ext','.'+ext);
      d.setAttribute('data-loop',q['vas-loop']==='1'?'true':'false');
      if(q['vas-start'])d.setAttribute('data-start',q['vas-start']);
      d.setAttribute('data-alt',im.getAttribute('alt')||'Product');
      if(im.parentNode)im.parentNode.replaceChild(d,im);
    }
  }
  function boot(){try{upgradeImgs();}catch(_){}
    var els=document.querySelectorAll('.vas-spin');for(var i=0;i<els.length;i++)init(els[i]);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot); // theme editor
  window.VasSpin={init:init,boot:boot};
})();
